function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "29",
  height: "28",
  viewBox: "0 0 29 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4608_40352)",
  stroke: "currentColor",
  strokeWidth: "1.4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.909 17.922L5.116 5.238h5.542l1.017 10.674M1.075 27.113h26.25v-13.58a1.294 1.294 0 00-1.618-1.252L1.95 18.433a1.167 1.167 0 00-.874 1.13l-.001 7.55zM9.54 1.026a8.094 8.094 0 013.493.724c8.668 3.7 12.25-.863 12.25-.863"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.242 27.115h-5.834v-5.25a1.167 1.167 0 011.167-1.167h3.5a1.166 1.166 0 011.167 1.167v5.25zM13.325 22.446h-1.75M7.492 22.446h-1.75"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4608_40352"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.2)",
  d: "M0 0h28v28H0z"
})))));